import { WithdrawFundsForm } from '../../../components/forms/Forms';
import { useEffect, useState } from 'react';
import { useGlobalContext } from '../../../context/context';
import secureLocalStorage from 'react-secure-storage';
import axios from 'axios';
import { PageSpinner } from '../../../components/spinner/Spinner';

const Withdraw = () => {
  const [loading, setLoading] = useState(true);
  const [wallets, setWallets] = useState([]);
  const { baseURL } = useGlobalContext();
  const { token } = JSON.parse(secureLocalStorage.getItem(`user-info`));

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await axios.get(`${baseURL}/admin-wallets`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setWallets(data);
        setLoading(false);
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
    };
    fetchData();
    // eslint-disable-next-line
  }, []);

  return (
    <main className='content withdrawal-page'>
      <div className='title'>
        <h3>Withdrawal</h3>
        <h2>What would you like to Withdraw today?</h2>
      </div>
      {loading ? <PageSpinner /> : <WithdrawFundsForm wallets={wallets} />}
    </main>
  );
};

export default Withdraw;
